module.exports = __webpack_public_path__ + "static/media/logo-facebook-white.e5ef4e93.svg";